import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import {
  isProductProtected as isProductProtectedInner,
  isProductHighlyProtected as isProductHighlyProtectedInner,
} from 'featureSliced/shared/utils/isProductProtected'

export const useProductProtection = () => {
  const productList = useMySelector((state) =>
    state.categories.items.flatMap((cat) => cat.products)
  )

  const isProductProtected = (productId: number) => {
    return isProductProtectedInner(
      productList?.find((product) => product.id === productId)
    )
  }

  const isProductHighlyProtected = (productId: number) => {
    return isProductHighlyProtectedInner(
      productList?.find((product) => product.id === productId)
    )
  }

  return {
    isProductProtected,
    isProductHighlyProtected,
  }
}
